<ng-container *ngIf="loading">
    <ngx-skeleton-loader [theme]="{
        width: '100%',
        height: '150px'
      }">
    </ngx-skeleton-loader>

    <app-spacer [bottom]="24"></app-spacer>

    <ngx-skeleton-loader [theme]="{
        width: '100%',
        height: '300px'
      }">
    </ngx-skeleton-loader>
</ng-container>

<ng-container *ngIf="!loading">
    <div class="dash-card no-padding">
        <div
            class=" dash-card-header d-flex align-items-start justify-content-between">
            <h2>{{label}}</h2>
        </div>

        <div class="dash-card-body padding-container mb-5">
            <div class="col-12" style="padding: 0 30px 20px;">
                <form [formGroup]="form">
                    <div class="row">
                        <div class="col-lg-4">
                            <app-input [group]="form" controlName="name"
                                label="Nome do grupo de permissões"
                                [maxLength]="60">
                            </app-input>
                        </div>

                        <div class="col-lg-2">
                            <app-spacer [top]="32"></app-spacer>
                            <app-radio
                                (onCheckChanged)="form.controls.active.setValue(!form.controls.active.value)"
                                [multiple]="true"
                                [isChecked]="form.controls.active.value">
                                Permissão ativa
                            </app-radio>
                        </div>

                        <div class="col-lg-6">
                            <p class="title">Criado por</p>
                            <p class="label">
                                {{isEditing ? createdBy :
                                user.active_register.register.name
                                }}
                            </p>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <div class="dash-card no-padding">
        <div class="dash-card-header d-block">
            <h2>Permissões</h2>
            <p>
                Utilize o controle abaixo para associar as permissões que
                gostaria de vincular a este grupo
            </p>
        </div>

        <div class="dash-card-body padding-container mb-5">
            <div class="col-12 permission-container"
                style="padding: 0 30px 20px;">
                <div class="permission-container-header">
                    <div class="left pt-0" style="border:0;">
                        <h3>Permissões disponíveis</h3>
                        <app-spacer [bottom]="8"></app-spacer>

                        <!-- <div class="permission-container-header-search">
                            <svg-icon src="assets/images/icon-search.svg"></svg-icon>
                            <app-spacer [right]="8"></app-spacer>
                            <app-input [group]="searchForm" style="width: 100%;"
                                controlName="avaliablePermissions"
                                [maxLength]="60">
                            </app-input>
                        </div> -->
                    </div>
                    <div class="right pt-0" style="border:0;">
                        <h3>Permissões escolhidas</h3>
                        <app-spacer [bottom]="8"></app-spacer>

                        <!-- <div class="permission-container-header-search">
                            <svg-icon src="assets/images/icon-search.svg"></svg-icon>
                            <app-spacer [right]="8"></app-spacer>
                            <app-input [group]="searchForm" style="width: 100%;"
                                controlName="selectedPermissions"
                                [maxLength]="60">
                            </app-input>
                        </div> -->
                    </div>
                </div>

                <div class="permission-container-body">
                    <div class="left">
                        <p class="permission-container-body-top-content">
                            <ng-container
                                *ngIf="permissionsAvaliable.length > 0">
                                <app-radio
                                    (onCheckChanged)="handleCheckAll(true)"
                                    [multiple]="true"
                                    [isChecked]="verifyCheckAll(true)">
                                </app-radio>
                            </ng-container>
                            {{avaliableCheckedNumber}} de
                            {{totalAvaliableOptions}} itens selecionados
                        </p>
                        <app-spacer [bottom]="16"></app-spacer>

                        <div class="item-list">
                            <app-permission-tree [permissions]="permissionTree"
                                [level]="0" [baseData]="permissionsBaseData"
                                [selectedPermissions]="permissionsAvaliablePicked"
                                (permissionChange)="handlePermissionSelection($event)">
                            </app-permission-tree>
                        </div>

                    </div>
                    <div class="buttons-container">
                        <button [disabled]="getDisabled(true)"
                            (click)="changeSide(true)">
                            <svg-icon src="assets/images/icon-right.svg"
                                fill="var(--light)"></svg-icon>
                        </button>

                        <button [disabled]="getDisabled()"
                            (click)="changeSide()">
                            <svg-icon src="assets/images/icon-left.svg"
                                fill="var(--light)"></svg-icon>
                        </button>
                    </div>
                    <div class="right">
                        <p class="permission-container-body-top-content">
                            <ng-container
                                *ngIf="visiblePermissionsSelected.length > 0">
                                <app-radio (onCheckChanged)="handleCheckAll()"
                                    [multiple]="true"
                                    [isChecked]="verifyCheckAll()">
                                </app-radio>
                            </ng-container>
                            {{selectedCheckedNumber}} de
                            {{totalSelectedOptions}} itens selecionados
                        </p>
                        <app-spacer [bottom]="16"></app-spacer>

                        <div class="item-list">
                            <app-permission-tree
                                [permissions]="selectedPermissionTree"
                                [level]="0" [baseData]="permissionsBaseData"
                                [selectedPermissions]="permissionsSelectedPicked"
                                (permissionChange)="handlePermissionSelection($event)">
                            </app-permission-tree>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="text-right">
        <app-button (onClick)="handleCancel()" class="add-button mr-2"
            [phantom]="true">
            Cancelar
        </app-button>
        <app-button (onClick)="handleAddPermission()"
            [disabled]="getSubmitDisabled()" class="add-button"
            [loading]="sendingRequest">
            Salvar grupo de permissões
        </app-button>
    </div>
</ng-container>

<!-- Modal de confirmação de saída -->
<app-carbon-warning-modal [active]="showExitModal" title="Sair"
    message="Tem certeza que deseja sair? As configurações inseridas serão perdidas e não poderão ser recuperadas."
    [confirmText]="'Sim, sair'" [cancelText]="'Não, continuar configurando'"
    [confirmAction]="confirmExit.bind(this)"
    [cancelAction]="cancelExit.bind(this)" (onClose)="cancelExit()">
</app-carbon-warning-modal>